import { render, staticRenderFns } from "./NotaCreditoGeneral.vue?vue&type=template&id=dc57a94c&"
import script from "./NotaCreditoGeneral.vue?vue&type=script&lang=js&"
export * from "./NotaCreditoGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports